module.exports = __webpack_public_path__ + "img/personal-loan.3b446d78.png";